import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M20 10v7c0 1.105-.895 2-2 2H7c-.837 0-1.553-.516-1.85-1.246-.073-.18-.114-.375-.132-.576l2.498-2.498c.651-.651.651-1.708 0-2.359L5.018 9.823c.02-.227.072-.444.162-.643C5.494 8.486 6.189 8 7 8V6c0-2.206 1.794-4 4-4h3c1.277 0 2.488.62 3.241 1.658.162.224.111.536-.112.698-.22.162-.534.113-.698-.111C15.867 3.466 14.957 3 14 3h-3C9.346 3 8 4.346 8 6v2h10c1.105 0 2 .895 2 2zM6.354 13.146l-3-3c-.195-.195-.512-.195-.707 0s-.195.512 0 .707l2.146 2.146H.5c-.276 0-.5.224-.5.5s.224.5.5.5h4.293l-2.146 2.146a.5003.5003 0 0 0 0 .707c.098.098.226.146.354.146s.256-.049.354-.146l3-3a.5003.5003 0 0 0 0-.707z',
  ],
  height: 20,
  width: 20,
});
